<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-alert
              border="right"
              colored-border
              type="error"
              elevation="2"
            >
              {{ $t('inactive.messages.inactive') }}
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

export default {
  data() {

  }
}
</script>
